/**
 * ci-collection-geometrics.js
 * JavaScript for the Geometrics collection page.
 *
 * Currently handles:
 *  - Brochure download link — GA4 event tracking (fires if gtag is present)
 *
 * Add any future Geometrics-specific JS here rather than inline in the template.
 */

(function () {
  'use strict';

  /**
   * Track brochure PDF downloads as a GA4 event.
   * Fires only if window.gtag is available (i.e. GA4 is loaded).
   * Silent no-op otherwise — safe to leave in even without GA4.
   */
  function initBrochureTracking() {
    var brochureBtn = document.querySelector('.ci-btn--brochure');
    if (!brochureBtn) return;

    brochureBtn.addEventListener('click', function () {
      if (typeof window.gtag !== 'function') return;

      window.gtag('event', 'file_download', {
        file_name: 'geometrics-brochure',
        file_extension: 'pdf',
        link_url: brochureBtn.getAttribute('href'),
        link_text: brochureBtn.innerText.trim()
      });
    });
  }

  /**
   * Initialise on DOMContentLoaded.
   * Guard against the script loading after the event has already fired.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrochureTracking);
  } else {
    initBrochureTracking();
  }

})();